import { render, staticRenderFns } from "./ManufacturingMaterialView.vue?vue&type=template&id=6c519e14&scoped=true&"
import script from "./ManufacturingMaterialView.vue?vue&type=script&lang=js&"
export * from "./ManufacturingMaterialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c519e14",
  null
  
)

export default component.exports